import { authApiService } from '@/api/authApiService';

export const deleteTransactionApi = (transactionId: string) => {
  const uri = `/organization/contracts/${transactionId}/`;

  return authApiService.DELETE(uri);
};
